/* eslint-disable camelcase */
import { Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

const gtag = (window['gtag' as any] || function gtag(){}) as any;
export interface GAEvent { 
  action: 'change_category' | 'share' | 'login' | 'register' | 'like' | 'comment' | 'search' | 'banner_click' | 'banner_view', 
  category?: string, 
  label?: string
}

@Injectable({ 
  providedIn: 'root' 
})
export class GAnalyticService {

  protected loaded: boolean = false;

  constructor(
    protected readonly route: Router,
  ) {}

  public init(id: string): void{
    if (this.loaded) return;

    this.loaded = true;
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${ id }`;
    script.async = script.defer = true;
    document.head.appendChild(script);

    const canon: HTMLLinkElement = document.head.getElementsByClassName('canon')[0] as HTMLLinkElement;
    script.onload = () => gtag('config', id);

    this.route.events.pipe((filter((val: Event) => val instanceof NavigationEnd))).subscribe((e: any) => {
      gtag('config', id, { page_path: e.url });
      canon.href = e.url;
    });
  }

  public pageView(): void{ gtag('event', 'page_view', { page_path: this.route.url }); }

  public event(p: GAEvent): void{ gtag('event', p.action, { 'event_category': p.category, 'event_label': p.label }); }
}
